/**
 * Lightweight scroll-in reveal for elements marked [data-scroll-reveal].
 * No dependency, no-op under prefers-reduced-motion, re-scans on theme editor section load.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-scroll-reveal]').forEach(function (element) {
      element.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  function observeAll(root) {
    root.querySelectorAll('[data-scroll-reveal]').forEach(function (element) {
      observer.observe(element);
    });
  }

  observeAll(document);

  // Re-observe elements inside sections added or edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
